// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"fe836994","446":"8a1b52c7","5773":"750d167c","6599":"98e86912","8859":"1f2987e2"}[chunkId] + ".chunk.css";
};